import { render } from "./Synopsis.vue?vue&type=template&id=8ac86b68&scoped=true"
import script from "./Synopsis.vue?vue&type=script&lang=js"
export * from "./Synopsis.vue?vue&type=script&lang=js"

import "./Synopsis.vue?vue&type=style&index=0&id=8ac86b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac86b68"]])

export default __exports__